<app-create-customer />

<div>
  <div class="row mt-3">
    <div class="col-9">
        <div class="mb-3 d-flex gap">
            <h2 class="title-list no-wrap">List of Customers</h2>
            @if (permissionsService.isAdmin){
            <input type="text" class="form-control input-label" placeholder="ICCID, IMEI or Username..." [(ngModel)]="textToSearchICCID" />
            <button class="btn btn-secondary no-wrap" [disabled]="!textToSearchICCID"
                    (click)="searchICCID()">
                <i class="bi bi-search margin-r-05"></i>SIM Search
            </button>
            }
        </div>
    </div>
    <div class="col-3 text-end">
      <div class="d-flex flex-row-reverse bd-highlight">
        <div class="me-3">
          <button *ngIf="
              permissionsService.editPermission &&
              permissionsService.readPermission
            " class="btn btn-secondary" (click)="exportCustomerListToExcel()">
            <i class="bi bi-file-earmark-excel"></i>
          </button>
        </div>

        <div class="me-3">
          <button class="btn btn-secondary" appTooltip="Show Archived Customers" (click)="isFilteredByStatus ? clearFilter() : filterByStatus(2)">
            <i class="bi bi-archive"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <div class="input-group mb-3">
        <span class="input-group-text" id="basic-addon1">
          <i class="bi bi-search"></i>
        </span>
        <input type="text" class="form-control input-label" placeholder="Search" [(ngModel)]="textoBusqueda" (input)="onSearchChange()" />
      </div>
    </div>
  </div>
  <div class="row d-none d-md-block">
    <div class="col-12">
      <div class="table-responsive rounded-5">
        <table class="table table-striped mb-0">
          <caption class="d-none">
            List of customers and their details
          </caption>
          <thead class="head-table" style="white-space: nowrap; background-color: #7ab956;">
            <tr>
              <th class="px-4 py-3 align-middle">Customer Account</th>
              <th class="px-4 py-3 align-middle sticky-left-col-header">Name</th>
              <th class="px-4 py-3 align-middle">Email</th>
              <th class="px-4 py-3 align-middle">Main Contact</th>
              <th class="px-4 py-3 align-middle">Contact Number</th>
              <th class="px-4 py-3 align-middle">Additional contact number</th>
              <th class="px-4 py-3 align-middle">#Plans</th>
              <th class="px-4 py-3 align-middle">#Devices</th>
              <th *ngIf="permissionsService.nameRoleLogged != 'Customer'" class="px-4 py-3 align-middle">
                Customer Since
              </th>
              <th class="px-4 py-3 align-middle">Status</th>
              <th class="px-4 py-3 align-middle sticky-right-col-header">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="
                let customer of customers
                  | search : textoBusqueda : camposBusqueda
                  | slice
                    : (paginationService.currentPage - 1) *
                        paginationService.recordsPerPage
                    : paginationService.currentPage *
                        paginationService.recordsPerPage
              ">
              <td class="px-4 py-3 align-middle" [style.opacity]="customer.userStatus === 0 ? '0.6' : '1'"
                  title="{{ customer.userId }}">
                {{ customer.userId }}
              </td>
              <td class="px-4 py-3 align-middle sticky-left-col-data" [style.opacity]="customer.userStatus === 0 ? '0.6' : '1'"
                  title="{{ customer.userNames }}" [ngStyle]="{
                  'min-width': '200px',
                  'max-width': '300px',
                  'word-wrap': 'break-word',
                  'white-space': 'normal'
                }">
                {{ customer.userNames }}
              </td>
              <td class="px-4 py-3 align-middle" [style.opacity]="customer.userStatus === 0 ? '0.6' : '1'"
                  title="{{ customer.userMail }}">
                {{ customer.userMail }}
              </td>
              <td class="px-4 py-3 align-middle" [style.opacity]="customer.userStatus === 0 ? '0.6' : '1'"
                  title="{{ customer.mainContact }}" [ngStyle]="{
                  'min-width': '200px',
                  'max-width': '300px',
                  'word-wrap': 'break-word',
                  'white-space': 'normal'
                }">
                {{ customer.mainContact }}
              </td>
              <td class="px-4 py-3 align-middle" [style.opacity]="customer.userStatus === 0 ? '0.6' : '1'"
                  title="{{ customer.userPhone }}" [ngStyle]="{
                  'min-width': '200px',
                  'max-width': '300px',
                  'word-wrap': 'break-word',
                  'white-space': 'normal'
                }">
                {{ customer.userPhone }}
              </td>
              <td class="px-4 py-3 align-middle" [style.opacity]="customer.userStatus === 0 ? '0.6' : '1'"
                  title="{{ customer.additionalContactNumber }}" [ngStyle]="{
                  'min-width': '200px',
                  'max-width': '300px',
                  'word-wrap': 'break-word',
                  'white-space': 'normal'
                }">
                {{ customer.additionalContactNumber }}
              </td>
              <td class="px-4 py-3 align-middle" [style.opacity]="customer.userStatus === 0 ? '0.6' : '1'"
                  title="{{ customer.numberPlans }}">
                {{ customer.numberPlans }}
              </td>
              <td class="px-4 py-3 align-middle" [style.opacity]="customer.userStatus === 0 ? '0.6' : '1'"
                  title="{{ customer.numberDevices }}">
                {{ customer.numberDevices }}
              </td>
              <td *ngIf="permissionsService.nameRoleLogged != 'Customer'" class="px-4 py-3 align-middle"
                  [style.opacity]="customer.userStatus === 0 ? '0.6' : '1'" title="{{ customer.seniorityDateString }}"
                  [ngStyle]="{
                  width: '200px',
                  'word-wrap': 'break-word',
                  'white-space': 'normal'
                }">
                {{ customer.seniorityDateString }}
              </td>
              <td class="px-4 py-3 align-middle">

                <!-- <div *ngIf="customer.userStatus === 1">
                  <span class="badge bg-success">Active</span>
                </div>

                <div *ngIf="customer.userStatus === 2">
                  <span class="badge bg-light text-dark">Archived</span>
                </div> -->
                <div *ngIf="customer.userStatus === 0 || customer.userStatus === 1" class="form-check form-switch">
                  <input class="form-check-input" type="checkbox" [(ngModel)]="customer.userStatus"
                         id="flexSwitchCheckDefault" [checked]="customer.userStatus === 1"
                         [disabled]="!permissionsService.editPermission" (change)="
                      toggleStatus($event, customer);
                      setSelectedCustomer(customer);
                      openConfirmationModal(customer)
                    " data-bs-toggle="modal" data-bs-target="#modalSwitch" />
                </div>
              </td>
              <td class="px-4 py-3 align-middle sticky-right-col-data">
                  <div class="d-flex gap-2">

                      <!-- Customer Account View -->
                      <button class="btn btn-info" *ngIf="customer.userStatus !== 2 && permissionsService.showCustomers"
                              (click)="navigateToCustomerAccount(customer)" appTooltip="Customer Account">
                          <i class="bi bi-person-vcard"></i>
                      </button>


                      <!-- Кнопка «Редактировать» с значком в виде карандаша в квадрате -->
                      <button *ngIf="customer.userStatus !== 2 && permissionsService.editPermission" class="btn btn-primary" (click)="navigateToCustomerPlans(customer)" appTooltip="Edit Customer">
                          <i class="bi bi-pencil-square"></i>
                      </button>

                      <!-- Кнопка «Удалить» со значком «Архив» -->
                      <button *ngIf="
                      customer.userStatus !== 2 &&
                      permissionsService.archivePermission
                    " class="btn btn-danger" data-bs-toggle="modal" data-bs-target="#modalArchive"
                              (click)="setArchivedCustomer(customer)" style="background-color: #f8d7da; border: 3px solid #f8d7da"
                              appTooltip="Archive Customer">
                          <i class="bi bi-archive" style="color: #b02a37"></i>
                      </button>

                      <!-- Кнопка «Восстановить» со значком «Архив» -->
                      <button *ngIf="
                      customer.userStatus === 2 &&
                      permissionsService.archivePermission
                    " class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#modalArchive"
                              (click)="setArchivedCustomer(customer)" style="background-color: #7ab956; border: 3px solid #7ab956"
                              appTooltip="Restore Customer">
                          <i class="bi bi-archive"></i>
                      </button>

                      <!-- Кнопка «Просмотр» с иконкой в виде глаза -->
                      <button class="btn btn-info" *ngIf="permissionsService.readPermission"
                              (click)="navigateToCustomerView(customer)" appTooltip="View Customer">
                          <i class="bi bi-eye"></i>
                      </button>

                      <!-- Кнопка «Назначить пользователей» с значком назначения пользователей -->
                      <button *ngIf="
                      customer.userStatus !== 2 &&
                      permissionsService.readPermission
                    " class="btn btn-info" (click)="navigateToCustomerUsers(customer)" appTooltip="Assign User">
                          <i class="bi bi-person-plus"></i>
                      </button>
                  </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <!-- Cards para mobile -->
  <div class="row d-md-none">
    <div class="col-12">
      <div *ngFor="
          let customer of customers
            | search : textoBusqueda : camposBusqueda
            | slice
              : (paginationService.currentPage - 1) *
                  paginationService.recordsPerPage
              : paginationService.currentPage * paginationService.recordsPerPage
        " class="card mb-3">
        <div class="card-body">
          <h5 class="card-title">{{ customer.userNames }}</h5>
          <p class="card-text">
            <strong>Account:</strong> {{ customer.userId }}<br />
            <strong>Email:</strong> {{ customer.userMail }}<br />
            <strong>Phone:</strong> {{ customer.userPhone }}<br />
            <strong>Plans:</strong> {{ customer.numberPlans }}<br />
            <strong>Devices:</strong> {{ customer.numberDevices }}<br />
            <!-- <strong *ngIf="permissionsService.nameRoleLogged != 'Customer'">Seniority date:</strong> {{ customer.seniorityDate}}<br /> -->
          </p>
          <div class="d-flex gap-2">
            <div *ngIf="customer.userStatus === 0 || customer.userStatus === 1" class="form-check form-switch">
              <input class="form-check-input" type="checkbox" [(ngModel)]="customer.userStatus"
                     id="flexSwitchCheckDefault" [checked]="customer.userStatus === 1"
                     [disabled]="!permissionsService.editPermission" (change)="
                  toggleStatus($event, customer);
                  setSelectedCustomer(customer);
                  openConfirmationModal(customer)
                " data-bs-toggle="modal" data-bs-target="#modalSwitch" />
            </div>
            <div *ngIf="customer.userStatus === 2">
              <span class="archived">Archived</span>
            </div>
            <!-- Botón Editar con icono pencil-square -->
            <button *ngIf="
                customer.userStatus !== 2 && permissionsService.editPermission
              " class="btn btn-info" (click)="navigateToCustomerPlans(customer)"
                    style="background-color: #d1e7dd; border: 3px solid #d1e7dd" appTooltip="Edit Customer">
              <i class="bi bi-pencil-square" style="color: #146c43"></i>
            </button>

            <!-- Botón Delete con icono archive -->
            <button *ngIf="
                customer.userStatus !== 2 &&
                permissionsService.archivePermission
              " class="btn btn-danger" data-bs-toggle="modal" data-bs-target="#modalArchive"
                    (click)="setArchivedCustomer(customer)" style="background-color: #f8d7da; border: 3px solid #f8d7da"
                    appTooltip="Archive Customer">
              <i class="bi bi-archive" style="color: #b02a37"></i>
            </button>

            <!-- Botón View con icono eye -->
            <button class="btn btn-success" style="background-color: #cfe2ff; border: 3px solid #cfe2ff"
                    *ngIf="permissionsService.readPermission" (click)="navigateToCustomerView(customer)"
                    appTooltip="View Customer">
              <i class="bi bi-eye" style="color: #0a58ca"></i>
            </button>
            <!-- Botón Asignar Users con icono de asignación de usuarios -->
            <button *ngIf="
                customer.userStatus !== 2 && permissionsService.readPermission
              " class="btn btn-info" (click)="navigateToCustomerUsers(customer)"
                    style="background-color: #d1e7dd; border: 3px solid #d1e7dd" appTooltip="Assign User">
              <i class="bi bi-person-plus" style="color: #146c43"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Paginacion -->
  <div class="row">
    <div class="col-12">
      <label>
        Showing
        {{
        (paginationService.currentPage - 1) *
        paginationService.recordsPerPage +
        1
        }}
        to
        {{
        paginationService.currentPage * paginationService.recordsPerPage < filteredCustomers.length ?
          paginationService.currentPage * paginationService.recordsPerPage : filteredCustomers.length }} out of {{
          filteredCustomers.length }} entries </label>
    </div>
  </div>
  <div class="row justify-content-center">
    <div class="col-12 d-flex justify-content-center">
      <nav aria-label="Page navigation example">
        <ul class="pagination">
          <li class="page-item" [class.disabled]="paginationService.currentPage === 1">
            <a class="page-link" href="javascript:void(0)" tabindex="-1" aria-disabled="true" (click)="previousPage()">
              <i class="bi bi-chevron-left"></i>
            </a>
          </li>
          <ng-container *ngIf="pages.length > 0">
            <ng-container *ngFor="let page of pages">
              <li class="page-item" [class.active]="page === paginationService.currentPage">
                <a class="page-link" href="javascript:void(0)" (click)="changePage(page)">{{ page }}</a>
              </li>
            </ng-container>
          </ng-container>
          <li class="page-item" [class.disabled]="
              paginationService.currentPage === paginationService.totalPages ||
              filteredCustomers.length <= paginationService.recordsPerPage
            ">
          <a class="page-link" href="javascript:void(0)" (click)="nextPage()">
            <i class="bi bi-chevron-right"></i>
          </a>
        </li>
        </ul>
      </nav>
    </div>
  </div>
</div>





<!-- Modal -->
<div id="modalSwitch" class="modal fade" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="d-flex align-items-center justify-content-center full-height">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel" style="font-weight: bold">
            Customer Active/Inactive
          </h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                  (click)="updateUserStatus(false)"></button>
        </div>
        <div class="modal-body">
          Are you sure you want to Activate/Deactivate this customer?
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="updateUserStatus(false)">
            Close
          </button>
          <button type="button" class="btn btn-primary" data-bs-dismiss="modal" (click)="updateUserStatus(true)">
            Yes, Activate/Desactivate
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Modal -->
<div class="modal fade" id="modalArchive" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="d-flex align-items-center justify-content-center full-height">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel" style="font-weight: bold">
                Customer {{ selectedCustomer?.['@userStatus'] === 2 ? 'Archive' : 'Restore' }}
            </h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                  (click)="updateUserStatus(false)"></button>
        </div>
        <div class="modal-body">
            Are you sure you want to {{ selectedCustomer?.['@userStatus'] === 2 ? 'Archive' : 'Restore' }} this customer?
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="updateUserStatus(false)">
            Close
          </button>
          <button type="button" class="btn btn-primary" data-bs-dismiss="modal" (click)="updateUserStatus(true)">
              Yes, {{ selectedCustomer?.['@userStatus'] === 2 ? 'Archive' : 'Restore' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>




<!-- Modal -->
<div #modalSearchICCDRef id="modalSearchICCD" class="modal fade" tabindex="-1" aria-labelledby="searchICCDResultLabel" aria-hidden="true">
  <div class="d-flex align-items-center justify-content-center full-height">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id1="searchICCDResultLabel" style="font-weight: bold">Search Results</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <div class="modal-body" style="max-height: 60vh; overflow-y: auto;">
          <div style="font-size: 150%" *ngIf="!searchResult" red><i class="bi bi-x-circle margin-r-05"></i>SIM card with this ICCID not found:<div param-value>{{textToSearchICCID}}</div></div>
          <div *ngIf="searchResult">
            <div style="font-size: 150%">
              <div green><i class="bi bi-check-lg margin-r-05"></i>SIM card found.</div>
            </div>
            <div margin-t>
              <div>
                <span param-name>Status</span>
                <span class="bold {{searchResult.status === 2 ? 'gray' : 'green' }}" param-value>{{searchResult.status === 2 ? 'Archived' : 'Active' }}</span>
              </div>
              <div>
                <span param-name>ICCID</span>
                <a param-value href="javascript:void(0)" (click)="navigateToICCID(searchResult.iccid)">{{searchResult.iccid}}</a>
              </div>
              <div>
                <span param-name>Owner</span>
                <a param-value href="javascript:void(0)" (click)="navigateToCustomerPlans(searchResult.userId)">{{searchResult.userName}}</a>
              </div>
              <div>
                <span param-name>Plan</span>
                <a param-value href="javascript:void(0)" (click)="navigateToCustomerPlanDevices(searchResult)">{{searchResult.planName}}</a>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button *ngIf="searchResult as result" type="button" class="btn btn-primary" data-bs-dismiss="modal" (click)="navigateToICCID(searchResult.iccid)">Open</button>
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
</div>

